export const languagesPipe ={
  ['es-MX']:'es-MX',
  ['en-US']:'en-US',
  ['du-NL']:'nds-NL',
  ['kr-KR']:'ko-KR',
  ['ja-JP']:'ja-JP',
  ['fr-FR']:'fr-FR',
  ['pt-PT']:'pt-PT',
  ['zh-CN']:'zh-CN',
}